import { LoadingSpinner } from '@pesto/ui';
import { Navigate } from 'react-router-dom';

import { UserRole } from '../__generated__/graphql/api';
import { routes } from '../constants/routes';
import { useCurrentRole } from '../hooks/useCurrentRole';

export const HomeRoute = () => {
  const { role, isLoading } = useCurrentRole();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <LoadingSpinner size={32} />
      </div>
    );
  }

  return <Navigate to={role === UserRole.SuperAdmin ? routes.dashboard : routes.userSearch} replace />;
};
